const validationEnMessages = {
  'validate.required': 'Required field',
  'validate.mail': 'Please provide a valid email',
  'validate.min.character': 'Minimum  {min} characters',
  'validate.number': 'Enter a valid number',
  'validate.email.already.in.use': 'The e-mail {email} already in use.',
};

export default validationEnMessages;
